import { Route } from 'react-router';
import { getBilledEventsPath } from '../path/path';
import { BilledEventsPage } from '../BilledEventsPage';

export const OpcoBillingRoutes = [
  <Route key={getBilledEventsPath()} path={getBilledEventsPath()} element={<BilledEventsPage />} />,
];
